const CONSENT_PAGEBREAK_SENTINEL_COMMENT =
  /<!--\s*ar-consent-pagebreak\s*-->/gi;
const CONSENT_PAGEBREAK_COMMENT = /<!--\s*pagebreak\s*-->/gi;
const CONSENT_PAGEBREAK_IMAGE = /<img\b[^>]*\bmce-pagebreak\b[^>]*>/gi;
const CONSENT_PAGEBREAK_SPAN =
  /<span\b(?=[^>]*\bdata-consent-pagebreak=["']true["'])[^>]*>[\s\S]*?<\/span>/gi;
const CONSENT_PAGEBREAK_PLACEHOLDER_MATCHER = /\u200b/g;
const TINYMCE_BOOKMARK_CHARACTER = /\ufeff/g;

export const prepareConsentHtmlForDisplay = (html = "") =>
  html
    .replace(CONSENT_PAGEBREAK_SENTINEL_COMMENT, "")
    .replace(CONSENT_PAGEBREAK_COMMENT, "")
    .replace(CONSENT_PAGEBREAK_IMAGE, "")
    .replace(CONSENT_PAGEBREAK_SPAN, "")
    .replace(CONSENT_PAGEBREAK_PLACEHOLDER_MATCHER, "")
    .replace(TINYMCE_BOOKMARK_CHARACTER, "");
